import React from "react";
import { Instagram } from "lucide-react";
import { VENUES } from "../mock";

export function Logo({ className = "h-8" }) {
  return (
    <img
      src="/lakeze_logo.webp"
      alt="人客多 Lakeze"
      className={className}
      draggable={false}
    />
  );
}

export function VenueCards({ compact = false }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4">
      {VENUES.map((v) => (
        <a
          key={v.id}
          href={v.ig}
          target="_blank"
          rel="noopener noreferrer"
          className="group block overflow-hidden rounded-xl border border-border bg-white shadow-sm transition hover:shadow-md hover:-translate-y-0.5"
        >
          <div className="relative aspect-[4/3] overflow-hidden">
            <img
              src={v.image}
              alt={v.name}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <span className="absolute left-2 top-2 rounded-full bg-brand px-2 py-0.5 text-[10px] font-medium text-white">
              人客多精選
            </span>
            <span className="absolute right-2 top-2 grid h-6 w-6 place-items-center rounded-full bg-white/90 text-brand opacity-0 transition group-hover:opacity-100">
              <Instagram className="h-3.5 w-3.5" />
            </span>
          </div>
          <div className="p-3">
            <p className="text-sm font-bold leading-tight">{v.name}</p>
            <p className="mt-0.5 text-xs font-medium text-brand">{v.tag}</p>
            {!compact && (
              <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">
                {v.desc}
              </p>
            )}
          </div>
        </a>
      ))}
    </div>
  );
}
